module.exports = "<app-site-dashboard></app-site-dashboard>\r\n\r\n  "